import { GiaType } from 'const';
import { createSelector } from 'reselect';
import { studyGiaListSelector, studyTrialExamSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const studyGiaListYearsSelector = createSelector(studyGiaListSelector, (studyGiaList) =>
  extractDatesFromNestedItems(studyGiaList, [
    {
      type: 'date',
      field: 'date',
    },
  ]),
);

export const studyOgeYearsSelector = createSelector(studyGiaListSelector, (studyGiaList) =>
  extractDatesFromNestedItems(
    studyGiaList.filter((gia) => gia.formaGia === GiaType.oge),
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);

export const studyEgeYearsSelector = createSelector(studyGiaListSelector, (studyGiaList) =>
  extractDatesFromNestedItems(
    studyGiaList.filter((gia) => gia.formaGia === GiaType.ege),
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);

export const studyGve9YearsSelector = createSelector(studyGiaListSelector, (studyGiaList) =>
  extractDatesFromNestedItems(
    studyGiaList.filter((gia) => gia.formaGia === GiaType.gve9),
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);

export const studyGve11YearsSelector = createSelector(studyGiaListSelector, (studyGiaList) =>
  extractDatesFromNestedItems(
    studyGiaList.filter((gia) => gia.formaGia === GiaType.gve11),
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);

export const studyOtherGiaYearsSelector = createSelector(studyGiaListSelector, (studyGiaList) =>
  extractDatesFromNestedItems(
    studyGiaList.filter(
      (gia) =>
        gia.formaGia === GiaType.writing ||
        gia.formaGia === GiaType.narration ||
        gia.formaGia === GiaType.interviewRus ||
        gia.formaGia === GiaType.other,
    ),
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);

export const studyTrialExamsYearsSelector = createSelector(studyTrialExamSelector, (studyGiaList) =>
  extractDatesFromNestedItems(studyGiaList.content, [
    {
      type: 'date',
      field: 'date',
    },
  ]),
);
